import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  value: string
  error?: React.ReactNode
  className?: string
}

const Input: React.FC<InputProps> = ({
  onChange,
  error,
  value,
  className,
  ...props
}) => {
  return (
    <div>
      <input
        {...props}
        value={value}
        onChange={onChange}
        className={`${css(styles.input, !!error && styles.error)} ${className}`}
      />
      {error && <span className={css(styles.errorMessage)}>{error}</span>}
    </div>
  )
}

const styles = StyleSheet.create({
  input: {
    padding: '14px 20px',
    background: '#F3F4F6',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    height: '52px',
    width: '100%',
    fontSize: '14px',
    boxSizing: 'border-box',
    transition: 'border-color 0.3s ease',
    ':focus': {
      borderColor: '#3B82F6',
      outline: 'none',
    },
    ':hover': {
      borderColor: '#D1D5DB',
    },
  },
  error: {
    borderColor: 'red',
  },
  errorMessage: {
    fontSize: '12px',
    color: 'red',
    fontFamily: 'Inter, sans-serif',
  },
})

export default Input
